import React from 'react';
export const JunctionIcon = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 0.333252H0.666667C0.298477 0.333252 0 0.631729 0 0.999919V4.99992C0 5.36811 0.298477 5.66659 0.666667 5.66659H2.16667V10.3331L1.50798 10.3333C1.04798 10.3333 1 10.4208 1 10.7888V13.198C1 13.566 1.04798 13.6666 1.50798 13.6666L3.77097 13.666C4.23097 13.666 4.33333 13.566 4.33333 13.198V10.7888C4.33333 10.4208 4.23097 10.3327 3.77097 10.3327L3.16667 10.3329L3.16667 8.49992H9.83333V10.3333H9.23228C9.19912 10.3333 9.16779 10.3331 9.13822 10.333C8.7576 10.3311 8.66667 10.3307 8.66667 10.6721V13.295C8.66667 13.663 8.77228 13.6666 9.23228 13.6666H11.5115C11.9715 13.6666 12 13.663 12 13.295V10.6721C12 10.331 11.9755 10.3311 11.6055 10.333C11.5765 10.3331 11.5449 10.3333 11.5115 10.3333H10.8333V7.99992C10.8333 7.72378 10.6095 7.49992 10.3333 7.49992H3.16667V5.66659H4.66667C5.03486 5.66659 5.33333 5.36811 5.33333 4.99992V0.999919C5.33333 0.631729 5.03486 0.333252 4.66667 0.333252ZM4.37778 1.33325H1V4.66659H4.37778V1.33325Z"
      fill="#111111"
    />
  </svg>
);
